import { Fragment, type FC } from 'react'

export const SUPPORT_EMAIL = 'support@hoteliate.com'

interface SupportEmailTextProps {
  text: string
  linkClassName?: string
}

/**
 * Renders notice text as plain text and turns each literal support address into
 * a mailto: link (#2072). Only that one address is linked: admin-entered text is
 * never parsed as HTML or markdown. `dir="ltr"` keeps the address readable
 * inside Hebrew sentences.
 */
export const SupportEmailText: FC<SupportEmailTextProps> = ({ text, linkClassName }) => {
  const parts = text.split(SUPPORT_EMAIL)
  return (
    <>
      {parts.map((part, i) => (
        <Fragment key={i}>
          {part}
          {i < parts.length - 1 && (
            <a href={`mailto:${SUPPORT_EMAIL}`} dir="ltr" className={linkClassName ?? 'font-medium underline'}>
              {SUPPORT_EMAIL}
            </a>
          )}
        </Fragment>
      ))}
    </>
  )
}
